import React from 'react';

function BarChart30({ data }: { data: { date: string; count: number }[] }) {
  const max = Math.max(1, ...data.map((d) => d.count));
  return (
    <div className="flex items-end gap-[2px] h-32">
      {data.map((d) => (
        <div
          key={d.date}
          data-testid="bar"
          title={`${d.date}: ${d.count}`}
          className="flex-1 bg-primary-500 rounded-t min-h-[2px]"
          style={{ height: `${(d.count / max) * 100}%` }}
        />
      ))}
    </div>
  );
}
export default BarChart30;
